import { Component, Input, OnChanges } from '@angular/core';
import { EecModalService } from '~app/modules/product/services/eec-modal.service';
import { RepairabilityLabel } from '~app/modules/product/models';
import { RepairabilityLabelUtils } from "~shared/modules/repairability-label/utils/repairability-label.utils";
import { Product } from "~app/modules/account/modules/buy-again/models";

@Component({
  selector: 'app-storefront-repairability-label',
  templateUrl: './repairability-label.component.html',
  styleUrls: ['./repairability-label.scss']
})

export class RepairabilityLabelComponent implements OnChanges {
  @Input() product: Product;
  @Input() isImageHasLabel: boolean;
  repairability: RepairabilityLabel;

  constructor(private eecModalService: EecModalService) { }

  ngOnChanges(): void {
    if(!this.repairability) {
      this.repairability = RepairabilityLabelUtils.getRepairability(this.product, this.isImageHasLabel);
    }
  }

  onRepairabilityLabelClick(event): void {
    if (!this.repairability.index) {
      return;
    }
    event.stopPropagation();
    event.preventDefault();
    this.eecModalService.openEecDocument(this.repairability.src, 'CATALOG.DETAILS_PAGE.RI_MODAL.TITLE');
  }

}
